var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "li",
    {
      staticClass: "cw-blockadder-item-wrapper",
    },
    [
      _c("span", {
        staticClass: "cw-sortable-handle cw-sortable-handle-blockadder",
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "cw-blockadder-item",
          class: ["cw-blockadder-item-" + _vm.type],
          on: {
            click: function click($event) {
              $event.preventDefault()
              return _vm.addBlock.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "header",
            {
              staticClass: "cw-blockadder-item-title",
            },
            [_vm._v("\n            " + _vm._s(_vm.title) + "\n        ")]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "cw-blockadder-item-description",
            },
            [_vm._v("\n            " + _vm._s(_vm.description) + "\n        ")]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "cw-blockadder-item-fav",
          attrs: {
            title: _vm.favButtonTitle,
          },
          on: {
            click: function click($event) {
              return _vm.toggleFavItem()
            },
          },
        },
        [
          _c("studip-icon", {
            attrs: {
              shape: _vm.blockTypeIsFav ? "star" : "star-empty",
              size: 20,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }